import React from "react";
import Modal from 'react-modal';
import ScrollAnimation from 'react-animate-on-scroll';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaInfoCircle} from "react-icons/fa";
import { IoMdCloseCircleOutline } from 'react-icons/io';
import 'animate.css';
import DOMPurify from "dompurify";

import SpDecor from '../../img/decor/sp_decor.png';


// СоцСети
const SocialIcons = ({ fbLink, instLink, linkedinLink, tiktokLink, openModal }) => {
    const socialLinks = [
        { link: fbLink, icon: <FaFacebookF className="w-4 h-4 text-[#000]" /> },
        { link: instLink, icon: <FaInstagram className="w-4 h-4 text-[#000]" /> },
        { link: linkedinLink, icon: <FaLinkedinIn className="w-4 h-4 text-[#000]" /> },
        { link: tiktokLink, icon: <FaTiktok className=" w-4 h-4 text-[#000]" /> },
    ];

    return (
        <div className="absolute -left-[18px] -top-[10px] rounded-full z-[20] space-y-2 
            bg-[#f4f0ea] p-[3px] border-[3px] border-[#f4f0ea] box-content text-center "
        >
            {socialLinks.map((social, index) =>
                social.link ? (
                    <a
                        key={index}
                        href={social.link}
                        className="block bg-white rounded-full p-2 hover:bg-[#f4f0ea] transition "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {social.icon}
                    </a>
                ) : null
            )}
            <button
                type="button"
                className="block bg-white rounded-full p-2 hover:bg-[#f4f0ea] transition"
                onClick={openModal}
            >
                <FaInfoCircle className="w-4 h-4 text-[#000]" />
            </button>
        </div>
    );
};

// Модалка Спикера
const SpeakerModal = ({ speaker, isOpen, closeModal }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            ariaHideApp={false}
            className="modal-container fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center"
        >
            <button
                onClick={closeModal}
                className="absolute top-0 right-0 p-4 text-red-800 hover:text-red-600 focus:outline-none"
            >
                <IoMdCloseCircleOutline className="text-red-800 text-4xl" />
            </button>

            <div className="bg-[#f4f0ea] w-full max-w-4xl p-6 shadow-lg m-9 overflow-hidden">
                <div className="overflow-y-auto h-[80vh] max-h-max">
                <div className="flex flex-col md:flex-row items-center md:items-start">
                    <div className="mb-4 md:mb-0 md:w-4/12 overflow-hidden " style={{ backgroundImage: `url(${SpDecor})` }}>
                        <img
                            src={speaker.acf.sm_image}
                            alt={speaker.post_title}
                            className="w-full h-auto "
                        />
                    </div>
                    <div className="md:w-4/6 md:pl-6 w-full sm:w-auto">
                        <div className="mb-4 pb-4 border-b-2">
                            <h3 className="text-3xl font-semibold text-center md:text-left mb-3">{speaker.post_title}</h3>
                            {speaker.acf.logo && (
                                <img
                                    src={speaker.acf.logo}
                                    alt="Logo"
                                    className="object-contain w-16 mb-4 m-auto md:ml-0"
                                    style={{"width": speaker.acf.logo_mw + "px"}}
                                />
                            )}
                            <p className="text-sm text-center md:text-left text-black">{speaker.acf.position}</p>
                        </div>
                        <div className="speacer-popup-info" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(speaker.acf.info, {sanitize: true})}} />
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    );
};

// Карточка Спикера
const SpeakerCard = ({ speaker, index }) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const bgClass = index % 2 === 0 ? "bg-[#c8d2db]" : "bg-[#e8b500]";

    return (
        <div className="bg-[#f4f0ea] shadow-lg flex flex-col items-center relative">
            <div className={`${bgClass} overflow-hidden relative`}>
                <img className="mx-auto w-full h-auto transition duration-[400ms wp-post-image] z-10 relative"
                    src={speaker.acf.sm_image}
                    alt={speaker.post_title}
                />

                <img className="w-[90%] h-auto absolute bottom-0 right-0"
                    src={SpDecor}
                />
            </div>

            <div className="relative p-4 pb-6 pt-0">
                <div className="relative -mt-[45px] mb-3 w-[94px] h-[94px] flex z-20 rounded-full justify-center bg-white p-3 shadow-lg mx-auto after:absolute after:left-[5px] after:top-[5px] after:border after:border-black after:w-[84px] after:h-[84px] after:rounded-full">
                    {speaker.acf.logo && (
                        <img
                            src={speaker.acf.logo}
                            alt="Logo"
                            className="object-contain block w-full max-w-[50px]"
                            style={{ width: speaker.acf.logo_mw + "px" }}
                        />
                    )}
                </div>

                <h3 className="text-lg mb-2 font-semibold text-center">
                    {speaker.post_title}
                </h3>

                <p className="text-sm text-center font-medium text-[#505050]">
                    {speaker.acf.position}
                </p>
            </div>

            <button onClick={openModal} className="absolute w-full h-full z-[10]" />

            <SpeakerModal speaker={speaker} isOpen={modalIsOpen} closeModal={closeModal} />

            <SocialIcons
                fbLink={speaker.acf.fb_link}
                instLink={speaker.acf.inst_link}
                linkedinLink={speaker.acf.linkedin_link}
                tiktokLink={speaker.acf.tiktok_link}
                openModal={openModal}
            />
        </div>
    );
};

// Основной компонент для отображения спикеров
const EventSpeakersBase = ({speacersData }) => {
    return (
        <>
            {speacersData && speacersData.length > 0 ? (
                <section className="relative bg-white py-[60px] lg:py-[120px] mb-[60px] lg:mb-[120px]" id="speacers">

                    <div className="container max-w-screen-xl mx-auto px-5">
                        
                        <h2 className="text-[30px] uppercase text-center font-bold relative z-10 xl:text-[55px] mb-8 lg:mb-12">Спікери 2026</h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                            {speacersData.map((speaker, index) => (
                                <SpeakerCard key={index} speaker={speaker} index={index} />
                            ))}
                        </div>

                    </div>

                </section>
            ) : null}
        </>
    );
};


export default EventSpeakersBase;
